(function(){
    angular
        .module('app')
        .directive('framePreview', framepreviewDirective);

    framepreviewDirective.$inject = ['$compile']
     function framepreviewDirective($compile){
	 // directive factory creates a link function
	 return {
	 scope:{'pagesimple':'=','control':'='},
	  link:function(scope, element, attrs) {
	  	scope.$watch("pagesimple",
	    function(value) {
	    	//console.log(value);
	   		//console.log(scope);
	   		var $body = angular.element(element[0].contentDocument.body),
	        template  = $compile('<div html-viewer="content">'+value+'</div>')(scope);
	    	$body.html(template);
	    });
	  }
	   
	 }
	}
})();